<!-- NOTICES -->
<template>
    <v-row no-gutters class="fill-height ">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense >
                <!-- // * DESCRIPTION -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> 
                            <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>                                                
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <!-- // * STATUS AND BUTTONS -->
                <v-col :cols="computedCols" class="px-2 d-flex align-center justify-end">
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" class="pb-1">
                            <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" class="">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true"  clearble background-color="white" v-model="filter.site" :items="sites" item-text="siteName" item-value="id" filled dense clearable :label="$t(`filters.site`)" hide-details></v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" class="d-flex pa-0 ma-0 mt-2 pr-1 justify-end align-end">
                    <appbutton label="START NEW ROLL CALL" icon="" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"  @click.native="rollCallDialog = true" />
                </v-col>
                <!-- // * TABLE -->
                <v-col class="px-2 tabledata pt-2" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search"
                        >
                        <!-- // HEADERS -->                        
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>     
                        
                        <!-- // ACTION -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                        </template>
                        
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 mb-10 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="9" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect">{{ item.site }}</div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.createdDateTime }}</div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.type }}</div>
                                </v-col>
                                <v-col cols="3" >
                                    <div class="d-flex align-center justify-center">
                                        <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>


                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright  />
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in">
            <rightpanel></rightpanel>
        </transition>
        <v-dialog v-model="rollCallDialog" transition="dialog-bottom-transmission" max-width="512">
            <v-card class="">
                <v-toolbar color="primary" elevation="0">
                    <app-text category="text-medium" class="white--text ml-4">Start Fire Roll Call</app-text>

                    <v-spacer />

                    <v-btn @click="rollCallDialog = false" icon dark>
                        <v-icon class="icons8-multiply" color="white" />
                    </v-btn>
                </v-toolbar>

                <div class="pa-4">
                    <app-text category="text-default-bold">You are about to start a Fire Roll Call</app-text>

                    <ul class="mt-4">
                        <li><app-text category="text-default" class="mt-4">The Register shows users who've SWAPPed today</app-text></li>
                        <li><app-text category="text-default" class="mt-4">Check off each person as you go</app-text></li>
                        <li><app-text category="text-default" class="mt-4">Tap a person's image to call them</app-text></li>
                        <li><app-text category="text-default" class="mt-4">Complete the form when you're finished</app-text></li>
                        <li><app-text category="text-default" class="mt-4">The timer will stop when you submit the form</app-text></li>
                        <li><app-text category="text-default" class="mt-4">You can cancel at any time</app-text></li>
                    </ul>

                    <appbutton @click.native="MIX_go('/fireRollCallRegister')" block="block" class="mt-4" type="black" label="Continue" />
                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            collection: 'users',
            collectionTitle: 'Users',
            collectionItem: 'fireRollCall',
            collectionItemTitle: 'Fire Roll Call',  
            langPath: 'firerollcall',
            columnsDialog: false,
            rollCallDialog: false,
            search: '', // Table Search
            sortBy: 'passName', // Default Table Sort By
            customWhere: [],
            form: {
                present: null,
            },
            filter: {
                // Default Filters
                sortAsc: true,
                site: '',
                userType: '',
                function: '',
            },
            tableData: [], // Table Data
            headers: [ // Table Headers
                { text: 'id',  value: 'id', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'name',  value: 'name', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'type',  value: 'type', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'site',  value: 'site', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'createdDateTime',  value: 'createdDateTime', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'createdUserData',  value: 'createdUserData', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'actions',  value: 'actions', align: 'end', sortable: false, hidden: false, hide: false, width: '136px' },
            ],
            // SITES
            sites: [],
            organisations: [],
            userTypes: [],
            functions: [ 'Production', 'Engineering', 'Shunters', 'Maintenance Control', 'Planning', 'Stores', 'Facilities', 'Train Presentation', 'Fleet Readiness'],
            // LOOKUP VALUES
            passTypes: [],
            passSeverities: [],
            // DELETED
            showDeleted: false,
            usersSelected: [],
            viewSelected: true,
            selectedTally: true,
            total: null,
            filteredHeaders: []

        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_lookupValues: 'GET_lookupValues',     
                GET_sites: 'GET_sites',
                GET_organisations: 'GET_organisations',                
                GET_help: 'GET_help'           
            }),
            // Computed Cols
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
            computedTableDataSite() {
                var t = this;
                var tableData = t.tableData;

                // Filter by Site
                if ((t.filter.site !== '') && (t.filter.site !== undefined) && (t.filter.site !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.site === item.lastSite.siteId;
                    });
                }
                return (tableData);
            },
            // Computed Table Data
            computedTableData() {
                var t = this;
                var tableData = t.tableData;
                
                                
                // Filter by Site
                if ((t.filter.site !== '') && (t.filter.site !== undefined) && (t.filter.site !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.site === item.site.siteName;
                    });
                }         


                // Filter by Search Mobile                
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item[t.collectionItem+'Name'].toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                // TODO FILTER REQUIORED FOR PASSES FROM AND PASSES TO
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        name: e.name,
                        type: e.type,
                        site: e.site.siteName,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData.userName,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                // Sort the Table by the Field in the Sort By Filter
                var sortResults = t.$sortBy(tableDataList, t.sortBy)
                if (!t.filter.sortAsc) {sortResults.reverse()}
                return (sortResults);      
            }
        },
        // * WATCH
        watch: {
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openFireRollCall'}),
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collectionTitle}`}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function(id, process, popup) {
                var t = this;
                var item = {}                
                t.dynamicComponentKey++; 
                item.process = process;
                item.popup = popup;
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collectionItem, id)
                    item.data = itemResult.data;
                } else {
                    item.data = null;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, 'fireRollCall');
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, 'fireRollCall');
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            // //* OLD
            // // GET USERS SNAPSHOT METHOD
            getTableData: async function () {
                var t = this;
                var collection = t.$firebase.db.collection(t.collectionItem)
                if (JSON.stringify(t.customWhere) !== '[]') {
                    for (var i = 0; i < t.customWhere.length; i++) {
                        var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                        collection = collection.where(query.field, query.operator, query.value)   
                    }
                }
                collection.onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },
        },
        // * MOUNTED
        async mounted() {
            // * DEFAULT MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
            
            t.getTableData(); // Get Table Data  
            // * LOOKUP RELATED MOUNTED
            // LOOKUPS
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            // GET SITES
            await t.MIX_sites(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY       
            t.userTypes = await t.GET_lookupValues('USERTYPES');
        },
    }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/styles.sass'

  @media #{map-get($display-breakpoints, 'md-and-up')}
    .selectedbanner
        position: fixed !important
        // z-index: 10 !important
        width: calc(100% - 45px) !important

  @media #{map-get($display-breakpoints, 'xs-only')}
    .selectedbanner
        background: red !important
        position: fixed !important
        z-index: 10 !important
        width: calc(100%) !important

</style>
